import React, {Component} from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import $ from 'jquery';

// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";

import "../style/RatingTable.css";

// RatingsTable Component
class RatingsTable extends Component {
  componentDidMount() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
  }

  censorEmail(email) {
    if (email) {
      return email.replace(email.substring(3,email.length - 4), "*********")
    }
  }

  render() {
    const data = this.props.data.map( row => ({
      ...row,
      average: (row.rating_1 + row.rating_2 + row.rating_3) / 3
    }));

    const columns = [
          {
            Header: 'Date',
            accessor: 'created',
            Cell: row => (
              moment(row.value).format('DD/MM/Y à HH:mm')
            )
          },
          {
            Header: 'Email',
            accessor: 'email',
            width: 300,
            Cell: row => {
              return <div>
                {row.row.average >= 4
                  && row.value
                  && row.value.length
                  && <i
                    className="pe-7s-mail mail-icon gradient-icon-blue" 
                    title="Le client ayant laissé une bonne notation, nous l'avons relancé par email pour lui suggérer de laisser un avis sur Google Maps."
                    data-toggle="tooltip"
                    data-placement="top"
                  />}
                  {!row.original.marketing && row.value && row.value.length
                  && <i
                    className="pe-7s-lock mail-icon gradient-icon-blue" 
                    title="Le client n'a pas souhaité être contacté pour des raisons commerciales. L'adresse e-mail est donc masquée."
                    data-toggle="tooltip"
                    data-placement="top"
                  />}
                {row.original.marketing ? row.value : this.censorEmail(row.value)}
              </div>;
            }
          },
          {
            Header: this.props.labels[0],
            accessor: 'rating_1',
            Cell: row => (
              <span>
                <span style={{
                  color: row.value < 3 ? '#ff2e00'
                    : (row.value >= 3 && row.value < 4) ? '#ffbf00'
                    : '#57d500',
                  transition: 'all .3s ease'
                }}>
                  &#x25cf;
                </span>
                &nbsp;
                {row.value}
              </span>
            )
          },
          {
            Header: this.props.labels[1],
            accessor: 'rating_2',
            Cell: row => (
              <span>
                <span style={{
                  color: row.value < 3 ? '#ff2e00'
                    : (row.value >= 3 && row.value < 4) ? '#ffbf00'
                    : '#57d500',
                  transition: 'all .3s ease'
                }}>
                  &#x25cf;
                </span>
                &nbsp;
                {row.value}
              </span>
            )
          },
          {
            Header: this.props.labels[2],
            accessor: 'rating_3',
            Cell: row => (
              <span>
                <span style={{
                  color: row.value < 3 ? '#ff2e00'
                    : (row.value >= 3 && row.value < 4) ? '#ffbf00'
                    : '#57d500',
                  transition: 'all .3s ease'
                }}>
                  &#x25cf;
                </span>
                &nbsp;
                {row.value}
              </span>
            )
          },
          {
            Header: 'Moyenne',
            accessor: 'average',
            Cell: row => (
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#dadada',
                    borderRadius: '2px'
                  }}
                >
                  <div
                    style={{
                      width: `${row.value * 20}%`,
                      height: '100%',
                      backgroundColor: (row.value * 20) > 80 ? '#85cc00'
                        : (row.value * 20) > 60 ? '#ffbf00'
                        : '#ff2e00',
                      borderRadius: '2px',
                      transition: 'all .2s ease-out'
                    }}
                  />
                </div>
              )
          }


    ];

    return (<div className="table-wrapper">
      <ReactTable
        data={data}
        columns={columns}
        defaultPageSize={20}
        className="-striped -highlight"
        defaultSorted={[
          {
            id: "created",
            desc: true
          }
        ]}
      />
    </div>);
  }
}

RatingsTable.propTypes = {
  data: PropTypes.array.isRequired,
  labels: PropTypes.array.isRequired,
};

export default RatingsTable;



// WEBPACK FOOTER //
// ./src/components/RatingsTable.js